(function () {
	const checkBackground = () => {
		const contactSections = document.querySelectorAll(".contact-section");
		console.log(contactSections);
		const footer = document.querySelector(".footer");
			if (footer.classList.contains("color-background-1")) {
				contactSections.forEach((section) => {
					section.classList.add("no-padding");
				});
			}
	};

    let reasonDropdown=document.getElementById('ContactForm-reason');
    reasonDropdown.addEventListener("change", function() {
      var selectedOption = this.options[this.selectedIndex];
      var showOrderNumber = selectedOption.getAttribute('data-ordernumber');
      if (showOrderNumber == "1") {
        let orderNumberField=document.getElementById('field--ordernumber');
        orderNumberField.style.display='block';
        orderNumberField.querySelector('input').setAttribute('required', '');
      } else {
        orderNumberField.querySelector('input').removeAttribute('required');
      }

    });

    let contactForm=document.getElementById('ContactForm');
    contactForm.addEventListener("submit", function() {
      console.log('Form submitted');    
    })
  
	document.addEventListener("shopify:section:load", function () {
		checkBackground();
	});

  
    
	checkBackground();
})();